import { render, staticRenderFns } from "./38.vue?vue&type=template&id=89da5fbc&"
import script from "./38.vue?vue&type=script&lang=js&"
export * from "./38.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports